import { useLocation } from 'quartz-routing/react-router';
import { useEffect } from 'react';
import { NEW_USER_SEARCH_PARAMS_KEY } from 'academy-navigation-lib/components/ACPage/ACPage';
import { ACRedirect } from 'academy-common-lib/components/ACRedirect';
import { isNewUser } from 'academy-common-lib/utils/url';
import { isNewCatalogUser } from '../../utils/utils.migrated';
import { WIZARD_URL_FRAGMENT } from '../../constants/Navigation.legacy';
import { jsx as _jsx } from "react/jsx-runtime";
const NewUserLanding = () => {
  const location = useLocation();
  useEffect(() => {
    if (isNewUser(location.search)) {
      try {
        localStorage.setItem(NEW_USER_SEARCH_PARAMS_KEY, location.search);
      } catch (error) {
        console.error(error);
      }
    }
  }, [location.search]);
  if (location.pathname !== '/' || !isNewCatalogUser(location.search)) {
    return null;
  }
  return /*#__PURE__*/_jsx(ACRedirect, {
    to: Object.assign({}, location, {
      pathname: WIZARD_URL_FRAGMENT
    })
  });
};
export default NewUserLanding;